export const GOOGLE_EVENTS = {
	LANDING_PASSED: 'landing_passed',
	// Same names as the web app's paywall
	SUBSCRIPTION_SHOWN: 'subscription_shown',
	SUBSCRIPTION_CONTINUE: 'subscription_continue',
};

export const GOOGLE_ID = {
	CLIENT_ID: 'client_id',
	GCLID: 'gclid',
};
